import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shell for the signed-out pages that aren't the login flow (/privacy, /terms):
// top bar with the logo, one content column, footer links. AppRouter lists these paths in publicRoutes,
// so they never redirect to /login and never show the app header.

export const publicFooterLinks = [
    { to: '/privacy', label: 'Privacy' },
    { to: '/terms', label: 'Terms' },
];

type Props = {
    pageTitle: string;
    className: string;
    children: React.ReactNode;
};

const PublicLayout = ({ pageTitle, className, children }: Props) => {
    const { pathname } = useLocation();

    useEffect(() => {
        const previous = document.title;
        document.title = pageTitle;
        return () => { document.title = previous; };
    }, [pageTitle]);

    return <div className={`public-layout ${className}`}>
        <a className="public-skip" href="#public-main">Skip to content</a>
        <header className="public-topbar">
            <Link to="/login" className="public-logo">
                <img src="/images/login/logo-mobile.svg" alt="Investi" />
            </Link>
            <Link to="/login" className="public-signin">Sign in</Link>
        </header>
        <main id="public-main" className="public-main" tabIndex={-1}>
            {children}
        </main>
        <footer className="public-footer">
            <span>© {new Date().getFullYear()} Investi</span>
            <nav aria-label="Legal and status">
                {publicFooterLinks.map(x =>
                    <Link key={x.to} to={x.to} aria-current={pathname === x.to ? 'page' : undefined}>{x.label}</Link>)}
            </nav>
        </footer>
    </div>;
}

export default PublicLayout;
